/**
 * Monkey patch for PrimeVue BlockUI to fix exit animation bug
 *
 * Issue: BlockUI mask blocks interactions even after blocked prop is set to false
 * PR: https://github.com/primefaces/primevue/pull/8347
 *
 * TODO: Remove this file when upgrading to PrimeVue >= 4.6.0
 */

import BlockUI from 'primevue/blockui';

export function applyBlockUITempFix() {
  // In Vue 3, methods are on the component's __vccOpts or default export
  const component = (BlockUI as any).default || BlockUI;

  if (!component || !component.methods) {
    console.warn('BlockUI.methods not found - monkey patch cannot be applied');
    console.info('BlockUI structure:', BlockUI);
    return;
  }

  // Store original methods
  const originalUnblock = component.methods.unblock;
  const originalRemoveMask = component.methods.removeMask;

  if (!originalUnblock || !originalRemoveMask) {
    console.warn('BlockUI unblock/removeMask methods not found');
    return;
  }

  // from  https://github.com/primefaces/primevue/pull/8347 PR changes
  // Override unblock method
  component.methods.unblock = function (this: any) {
    this.isBlocked = false; // Fix 1
    this.$emit('unblock'); // Fix 2

    if (this.mask) {
      this.mask.style.pointerEvents = 'none'; // Fix 3
    }

    // Always call original unblock - it handles both mask/no-mask cases
    originalUnblock.call(this);
  };

  // Override removeMask method
  component.methods.removeMask = function (this: any) {
    // Fix 4
    if (!this.mask) {
      return;
    }

    // Call original removeMask logic
    originalRemoveMask.call(this);

    this.mask = null; // Fix 5
  };

  console.info('✅ PrimeVue BlockUI monkey patch applied');
}
